export default "__VITE_ASSET__Gdg5N0VK__"